import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface FC242 {
  fc242_01: string;
  fc242_02: number;
  fc242_03: number;
  fc242_10: string;
  fc242_101: string;
  fc242_102: string;
  fc242_103: number;
  fc242_11: number;
  fc242_14: number;
  fc242_141: number;
}

export interface FC241 {
  fc241_01: string;
  fc241_02: number;
  fc241_10: string;
  fc241_101: number;
  fc241_11: string;
  fc241_111: string;
  fc241_112: string;
  fc241_12: string;
  fc241_13: number;
  fc241_15: number;
  fc241_151: number;
  fc241_16: number;
  fc241_17: string;
  fc241_18: number;
  fc241_181: number;
  fc241_19: number;
  fc241_191: number;
  fc241_20: boolean;
  fc241_21: number;
  colors: FC242[];
}

export interface FC240 {
  fc240_01: string;
  fc240_02: string;
  fc240_10: string;
  fc240_11: string | null;
  fc240_12: string;
  fc240_121: string;
  fc240_13: string;
  fc240_131: string;
  fc240_14: string;
  fc240_141: string;
  fc240_15: string;
  fc240_151: string;
  fc240_16: string;
  fc240_161: string;
  fc240_17: string;
  fc240_18: string;
  fc240_19: number;
  fc240_20: string;
  fc240_21: string;
  fc240_211: string;
  fc240_22: boolean;
  fc240_221: string;
  fc240_222: string | null;
  fc240_23: string;
  fc240_231: number;
  fc240_232: number;
  fc240_233: number;
  fc240_24: number;
  fc240_241: number;
  fc240_25: number;
  fc240_251: number;
  fc240_26: string;
  fc240_261: string;
  fc240_262: string | null;
  fc240_263: string | null;
  fc240_264: string;
  fc240_265: string;
  fc240_266: string;
  fc240_267: string;
  fc240_27: boolean;
  fc240_271: string;
  fc240_272: string | null;
  fc240_273: string;
  fc240_28: boolean;
  fc240_281: string;
  fc240_282: string;
  fc240_283: string | null;
  fc240_284: string;
  fc240_285: string | null;
  fc240_286: string | null;
  fc240_287: string;
  fc240_288: string;
  fc240_289: string;
  fc240_28a: string;
  fc240_28b: string;
  fc240_29: boolean;
  fc240_291: string;
  fc240_292: string;
  fc240_293: string | null;
  fc240_294: string;
  fc240_295: string | null;
  fc240_296: string | null;
  fc240_297: string;
  fc240_298: string;
  fc240_299: number;
  fc240_29a: string;
  fc240_30: string;
  fc240_31: string;
  fc240_32: string;
  fc240_33: string;
  fc240_34: number;
  fc240_351: string;
  fc240_352: string;
  fc240_353: string;
  fc240_354: string;
  fc240_355: string;
  fc240_36: string;
  fc240_361: string;
  fc240_371: string | null;
  fc240_80: string;
  fc240_91: string;
  fc240_92: string | null;
  fc240_93: string;
  details: FC241[];
}

export interface ListResponse {
  data: FC240[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const c203Api = {
  async list(page = 1, size = 20, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/pwc203f1', { params });
    return res.data;
  },

  async get(orderNo: string): Promise<FC240> {
    const res = await apiClient.get(`/api/pwc203f1/${encodeURIComponent(orderNo)}`);
    return res.data;
  },

  async importSource(sourceType: 'export' | 'domestic', orderNo: string, line?: number): Promise<FC240> {
    const params = line ? { line } : undefined;
    const res = await apiClient.get(
      `/api/pwc203f1/source-import/${sourceType}/${encodeURIComponent(orderNo)}`,
      { params },
    );
    return res.data;
  },

  async create(data: Partial<FC240>): Promise<FC240> {
    const res = await apiClient.post('/api/pwc203f1', data);
    return res.data;
  },

  async update(orderNo: string, data: Partial<FC240>): Promise<FC240> {
    const res = await apiClient.put(`/api/pwc203f1/${encodeURIComponent(orderNo)}`, data);
    return res.data;
  },

  async delete(orderNo: string): Promise<void> {
    await apiClient.delete(`/api/pwc203f1/${encodeURIComponent(orderNo)}`);
  },

  async updateStatus(orderNo: string, status: string): Promise<void> {
    await apiClient.patch(`/api/pwc203f1/${encodeURIComponent(orderNo)}/status`, { status });
  },
};
